import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';
import '../../styles/core.scss';
import css from './library-item-detail.scss';
import ChapterDetail from '../chapter-detail/chapter-detail';
import { ANALYTICS_EVENTS, trackEvent } from '../../analytics';
import { getConfigValue } from '../../config';
import { getAuthToken } from '../../helpers/auth';

class LibraryItemDetail extends Component {
    static propTypes = {
        item: PropTypes.object,
        productId: PropTypes.string
    };

    trackEbookDownloaded = () => {
        const { id, title, type } = this.props.item;

        trackEvent(ANALYTICS_EVENTS.ebookDownloaded, {
            itemId: id,
            itemType: type,
            productId: this.props.productId,
            title
        });
    };

    logBookDownloadStats = () => {
        const { id, title, seriesName } = this.props.item;
        const BASE_URL = getConfigValue('MathleticsLibraryGatewayUrl');
        const bookDownloadLogUrl = `${BASE_URL}/api/log/book-download?series=${seriesName}&bookTitle=${title}&bookId=${id}`;
        this.trackEbookDownloaded();

        getAuthToken()
            .then(authToken => fetch(bookDownloadLogUrl, {
                method: 'POST',
                headers: {
                    AuthToken: authToken
                }
            }));
    };

    download = (downloadUrl) => {
        this.trackEbookDownloaded();
        this.window.open(downloadUrl, '_blank');
    };

    render() {
        let chapters = [];
        let downloadButton = '';
        const interactives = [];
        const videos = [];
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
        if (this.props.item.chapters.length > 0) {
            chapters = this.props.item.chapters;
        }
        if (this.props.item.interactives.length > 0) {
            _.map(this.props.item.interactives, item => interactives.push({ id: item.id, title: item.title, documentUrl: item.url }));
        }
        if (this.props.item.videos.length > 0) {
            _.map(this.props.item.videos, item => videos.push({ id: item.id, title: item.title, documentUrl: item.url }));
        }
        if (isMobile) {
            downloadButton = (<button className={css.downloadButton} onClick={() => this.download(this.props.item.documentUrl)}><Trans id="Download eBook">Download eBook</Trans></button>);
        } else {
            downloadButton = (
                <div className={css.downloadButtonContainer}>
                    <a
                        onClick={this.logBookDownloadStats}
                        className={css.downloadButton}
                        href={this.props.item.documentUrl}
                        download={this.props.item.title}
                        target="_blank">
                            <Trans>Download eBook</Trans>
                    </a>
                </div>);
        }
        return (
            <div className={css.component}>
                <div className={css.itemInfo}>
                    <p className={css.seriesName}>{this.props.item.seriesName}</p>
                    <p className={css.title}>{this.props.item.title}</p>
                    <p className={css.itemType}>{this.props.item.type}</p>
                    {downloadButton}
                </div>
                {
                    _.map(chapters, chapter =>
                        <ChapterDetail key={chapter.Id + chapter.title} title={chapter.title} units={chapter.units} documentUrl={chapter.documentUrl} titleClassName={css.chapterTitle} unitClassName={css.unitTitle} />
                    )
                }
                <ChapterDetail title="Interactives" units={interactives} documentUrl="" titleClassName={css.interactiveTitle} unitClassName={css.unitTitle} />
                <ChapterDetail title="Videos" units={videos} documentUrl="" titleClassName={css.videoTitle} unitClassName={css.unitTitle} />
            </div>
        );
    }
}

export default LibraryItemDetail;
